export class BillableEntity {
    _id: number;
    _name: string;
    _address: string;
    _postCode: string;
    _city: string;
    _phoneNumber: string;
    _email: string;


    constructor(id: number, name: string, address: string, postCode: string, city: string, phoneNumber: string, email: string)
    {
        this._id = id;
        this._name = name;
        this._address = address;
        this._postCode = postCode;
        this._city = city;
        this._phoneNumber = phoneNumber;
        this._email = email;
    }

    serialize() {
        return {
            id: this._id,
            name: this._name,
            address: this._address,
            postCode: this._postCode,
            city: this._city,
            phoneNumber: this._phoneNumber,
            email: this._email
        }
    }
}
